export function LivePulse({ active, label = true, size = 10 }) {
  return (
    <div className="inline-flex items-center gap-2" data-testid="live-pulse">
      <span className="relative inline-flex" style={{ width: size, height: size }}>
        {active && (
          <span
            className="absolute inset-0 rounded-full"
            style={{ background: "#FF3B30", animation: "vox-pulse-ring 1.6s ease-out infinite" }}
          />
        )}
        <span
          className="relative inline-flex rounded-full"
          style={{
            width: size,
            height: size,
            background: active ? "#FF3B30" : "#52525B",
            boxShadow: active ? "0 0 10px #FF3B30" : "none",
          }}
        />
      </span>
      {label && (
        <span
          className={`font-mono text-xs tracking-widest uppercase ${active ? "text-live" : "text-zinc-500"}`}
        >
          {active ? "On Air" : "Off Air"}
        </span>
      )}
    </div>
  );
}
